/* eslint-disable react/no-danger */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Divider, Group, Stack, Text } from '@mantine/core';
import moment from 'moment';
import { FC, useContext } from 'react';
import { MailS } from '../../Service/MailS';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import { MessageText } from '../../Atoms/MessagePlaceholderText';

const ReplyMessagePreview: FC<{ withPadding?: boolean }> = ({ withPadding = false }) => {
  const { selectedMessage } = useContext(EmailBoxContext);

  if (!selectedMessage) {
    return null;
  }
  return (
    <Group noWrap ml={withPadding ? 15 : 0} mb="lg" mt="sm">
      <Divider size="xl" orientation="vertical" sx={{ borderRadius: 10 }} />
      <Stack>
        <Text color="blue">
          Am {moment(selectedMessage.lastModified).format('D MMM YYYY, [um] HH:mm')}
          {' Uhr '}
          schrieb{'  '}
          <Text span weight="bolder">
            {MailS.getParticipantAddress(selectedMessage.from)}
          </Text>
          :{' '}
        </Text>
        <MessageText htmlValue={selectedMessage.message} />
      </Stack>
    </Group>
  );
};

export default ReplyMessagePreview;
